import React from 'react';
import { HeadingContextProvider } from '@atlaskit/heading';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { InsightObjectViewSkeleton } from '@atlassian/jira-skeletons/src/ui/insight-object/InsightObjectViewSkeleton.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { ObjectViewProps } from './common/types.tsx';

const LazyObjectView = lazyForPaint(
	() => import(/* webpackChunkName: "insight-object-view" */ './main'),
);

export const AsyncObjectView = (props: ObjectViewProps): React.JSX.Element => (
	<Placeholder name="insight-object-view" fallback={<InsightObjectViewSkeleton />}>
		<HeadingContextProvider value={2}>
			<LazyObjectView {...props} />
		</HeadingContextProvider>
	</Placeholder>
);
